import { track } from './analyticsAdapterClient';

export function doBannerClickTracking(EventLabel) {
    track({ event: 'in_page_navigation', payload: { EventAction: 'CrossSellBanners', EventLabel } });
}
